"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6959],{

/***/ 76959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_OurHrTeam; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./components/sections/OurHrTeam/ourHrTeam.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e11qljp0"
})("display:flex;flex-direction:column;", mixins/* defaultContainerSize */.sX, ";margin-top:4rem;margin-bottom:4rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e11qljp1"
})("font-size:2rem;line-height:2.5rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-weight:400;margin:0 0 2.5rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const PersonsList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "e11qljp2"
})("margin:0;padding:0;list-style:none;");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/images/MailImage/MailImage.tsx

const Mail = ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z",
                stroke: "url(#paint0_linear_10075_167806)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M22 6L12 13L2 6",
                stroke: "url(#paint1_linear_10075_167806)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "paint0_linear_10075_167806",
                        x1: "2",
                        y1: "3.99999",
                        x2: "24.504",
                        y2: "9.2343",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#0E4ED7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0.484375",
                                stopColor: "#7B4B93"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#F94743"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "paint1_linear_10075_167806",
                        x1: "2",
                        y1: "5.99999",
                        x2: "20.4942",
                        y2: "15.8323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                stopColor: "#0E4ED7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "0.484375",
                                stopColor: "#7B4B93"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "1",
                                stopColor: "#F94743"
                            })
                        ]
                    })
                ]
            })
        ]
    });

;// CONCATENATED MODULE: ./components/images/MailImage/index.ts

/* harmony default export */ var MailImage = (Mail);

;// CONCATENATED MODULE: ./components/images/PhoneImage/PhoneImage.tsx

const Phone = ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21.9975 16.9201V19.9201C21.9986 20.1986 21.9416 20.4743 21.83 20.7294C21.7184 20.9846 21.5548 21.2137 21.3496 21.402C21.1443 21.5902 20.9021 21.7336 20.6382 21.8228C20.3744 21.912 20.0949 21.9452 19.8175 21.9201C16.7403 21.5857 13.7845 20.5342 11.1875 18.8501C8.77132 17.3148 6.72283 15.2663 5.18749 12.8501C3.49747 10.2413 2.44573 7.27109 2.11749 4.1801C2.0925 3.90356 2.12537 3.62486 2.21399 3.36172C2.30262 3.09859 2.44506 2.85679 2.63226 2.65172C2.81945 2.44665 3.0473 2.28281 3.30128 2.17062C3.55527 2.05843 3.82983 2.00036 4.10749 2.0001H7.10749C7.5928 1.99532 8.06328 2.16718 8.43125 2.48363C8.79922 2.80008 9.03957 3.23954 9.10749 3.7201C9.23411 4.68016 9.46894 5.62282 9.80749 6.5301C9.94204 6.88802 9.97115 7.27701 9.8914 7.65098C9.81164 8.02494 9.62635 8.36821 9.35749 8.6401L8.08749 9.9101C9.51105 12.4136 11.5839 14.4865 14.0875 15.9101L15.3575 14.6401C15.6294 14.3712 15.9726 14.1859 16.3466 14.1062C16.7206 14.0264 17.1096 14.0556 17.4675 14.1901C18.3748 14.5286 19.3174 14.7635 20.2775 14.8901C20.7633 14.9586 21.2069 15.2033 21.524 15.5776C21.8412 15.9519 22.0097 16.4297 21.9975 16.9201Z",
                stroke: "url(#paint0_linear_10075_167811)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_10075_167811",
                    x1: "2.10938",
                    y1: "1.99998",
                    x2: "24.9125",
                    y2: "6.23468",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#0E4ED7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0.484375",
                            stopColor: "#7B4B93"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#F94743"
                        })
                    ]
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./components/images/PhoneImage/index.ts

/* harmony default export */ var PhoneImage = (Phone);

// EXTERNAL MODULE: ./utils/phoneNumberFormatter.ts
var phoneNumberFormatter = __webpack_require__(38782);
;// CONCATENATED MODULE: ./components/images/LinkedinGradientImage/LinkedinGradientImage.tsx

const LinkedinGradientImage = ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.75 4C2.75 3.30964 3.30964 2.75 4 2.75C4.69036 2.75 5.25 3.30964 5.25 4C5.25 4.69036 4.69036 5.25 4 5.25C3.30964 5.25 2.75 4.69036 2.75 4ZM4 1.25C2.48122 1.25 1.25 2.48122 1.25 4C1.25 5.51878 2.48122 6.75 4 6.75C5.51878 6.75 6.75 5.51878 6.75 4C6.75 2.48122 5.51878 1.25 4 1.25ZM16 8.75C14.6076 8.75 13.2723 9.30312 12.2877 10.2877C11.3031 11.2723 10.75 12.6076 10.75 14V20.25H13.25V14C13.25 13.2707 13.5397 12.5712 14.0555 12.0555C14.5712 11.5397 15.2707 11.25 16 11.25C16.7293 11.25 17.4288 11.5397 17.9445 12.0555C18.4603 12.5712 18.75 13.2707 18.75 14V20.25H21.25V14C21.25 12.6076 20.6969 11.2723 19.7123 10.2877C18.7277 9.30312 17.3924 8.75 16 8.75ZM11.227 9.22703C12.4929 7.96116 14.2098 7.25 16 7.25C17.7902 7.25 19.5071 7.96116 20.773 9.22703C22.0388 10.4929 22.75 12.2098 22.75 14V21C22.75 21.4142 22.4142 21.75 22 21.75H18C17.5858 21.75 17.25 21.4142 17.25 21V14C17.25 13.6685 17.1183 13.3505 16.8839 13.1161C16.6495 12.8817 16.3315 12.75 16 12.75C15.6685 12.75 15.3505 12.8817 15.1161 13.1161C14.8817 13.3505 14.75 13.6685 14.75 14V21C14.75 21.4142 14.4142 21.75 14 21.75H10C9.58579 21.75 9.25 21.4142 9.25 21V14C9.25 12.2098 9.96116 10.4929 11.227 9.22703ZM1.25 9C1.25 8.58579 1.58579 8.25 2 8.25H6C6.41421 8.25 6.75 8.58579 6.75 9V21C6.75 21.4142 6.41421 21.75 6 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21V9ZM2.75 9.75V20.25H5.25V9.75H2.75Z",
                fill: "url(#paint0_linear_10075_167815)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_10075_167815",
                    x1: "1.25",
                    y1: "1.24998",
                    x2: "25.8151",
                    y2: "6.04392",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#0E4ED7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "0.484375",
                            stopColor: "#7B4B93"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#F94743"
                        })
                    ]
                })
            })
        ]
    });

;// CONCATENATED MODULE: ./components/images/LinkedinGradientImage/index.ts

/* harmony default export */ var images_LinkedinGradientImage = (LinkedinGradientImage);

// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/sections/OurHrTeam/Person/person.styles.tsx

function person_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 0;\n  "
    ]);
    person_styles_templateObject = function() {
        return data;
    };
    return data;
}
function person_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    column-gap: 1.875rem;\n  "
    ]);
    person_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: flex-start;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2rem;\n    line-height: 2.5rem;\n    text-align: left;\n    margin-bottom: 0.5rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: left;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: left;\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: none;\n    color: ",
        ";\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}





const PersonImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1eixfzz0"
})("width:100%;height:100%;max-height:22.5rem;max-width:16.875rem;border-radius:1rem;object-fit:cover;margin:0 auto;img{max-height:22.5rem;max-width:16.875rem;width:100%;height:100%;border-radius:1rem;}", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(person_styles_templateObject())), ";");
const PersonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "e1eixfzz1"
})("display:flex;flex-direction:column;row-gap:1.875rem;margin-bottom:2.5rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(person_styles_templateObject1())), ";&:last-of-type{margin-bottom:0;}");
const PersonContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1eixfzz2"
})("display:flex;flex-direction:column;");
const PersonSocialLinks = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1eixfzz3"
})("display:flex;flex-direction:column;align-items:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const PersonName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1eixfzz4"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:1.5rem;font-weight:400;line-height:2rem;margin:0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";text-align:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const PersonPosition = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1eixfzz5"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:1rem;font-weight:400;line-height:2rem;margin:0 0 1rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";text-align:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const PersonBio = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1eixfzz6"
})(Typography/* ParagraphS */.fw, ";letter-spacing:0.0125rem;margin:0 0 1rem 0;max-width:35.625rem;text-align:center;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const PersonSocialLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1eixfzz7"
})("display:flex;flex-direction:row;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";font-size:1rem;font-weight:400;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";gap:1rem;align-items:center;text-decoration:underline;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject6(), theme/* THEME.colors.core_black */.C.colors.core_black)), ";");

// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./components/sections/OurHrTeam/Person/Person.tsx










const Person = (param)=>{
    let { hr_person_image , hr_person_name , hr_person_title , hr_person_bio , hr_person_mail , hr_person_phone , hr_person_linkedin  } = param;
    const { medium  } = (0,useWindowSize/* useWindowSize */.i)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonWrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonImageWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    ...(0,imageSerializer/* imageSerializer */.l)(hr_person_image)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonContent, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonName, {
                        children: prismic_reactjs.RichText.asText(hr_person_name)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonPosition, {
                        children: prismic_reactjs.RichText.asText(hr_person_title)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonBio, {
                        children: prismic_reactjs.RichText.asText(hr_person_bio)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonSocialLinks, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonSocialLink, {
                                href: "mailto:".concat(prismic_reactjs.RichText.asText(hr_person_mail)),
                                children: [
                                    medium && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MailImage, {}),
                                    prismic_reactjs.RichText.asText(hr_person_mail)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonSocialLink, {
                                href: "tel:".concat(prismic_reactjs.RichText.asText(hr_person_phone)),
                                children: [
                                    medium && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhoneImage, {}),
                                    (0,phoneNumberFormatter/* formatPhoneNumber */.u)(prismic_reactjs.RichText.asText(hr_person_phone))
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonSocialLink, {
                                href: prismic_reactjs.RichText.asText(hr_person_linkedin),
                                target: "_blank",
                                children: [
                                    medium && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(images_LinkedinGradientImage, {}),
                                    prismic_reactjs.RichText.asText(hr_person_name)
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/OurHrTeam/OurHrTeam.tsx



const OurHrTeam = (param)=>{
    let { titleAs , title , team  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                as: titleAs,
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonsList, {
                children: team.map((item, index)=>{
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Person, {
                        ...item
                    }, index);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/OurHrTeam/index.ts

/* harmony default export */ var sections_OurHrTeam = (OurHrTeam);


/***/ }),

/***/ 38782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
const formatPhoneNumber = (number)=>{
    if (!number) return;
    if (number.length === 9) {
        return "".concat(number.slice(0, 3), " ").concat(number.slice(3, 6), " ").concat(number.slice(6, 9));
    } else if (number.length === 12) {
        return "".concat(number.slice(0, 3), " ").concat(number.slice(3, 6), " ").concat(number.slice(6, 9), " ").concat(number.slice(9, 12));
    } else return number;
};


/***/ })

}]);